import React from "react";
import classNames from "classnames";
import Modal from "components/base/Modal";
import css from "./style.scss";
import { downloadContactsWithNoNumber } from "../../data/property";
import { useDispatch, useSelector } from "react-redux";
import { getAppendJobEstimate } from "data/contacts/actions";
import { selectAppendGroups } from "data/contacts";
import SkipTraceModal from "app/components/SkipTraceModal";
import InfoAlert from "app/components/InfoAlert";


const MissingPhoneNumbers = ({
    isOpen,
    onClose,
    campaignName,
    missingCount,
    preflightResponse,
    onContinueWithoutSkipTrace,
    showToastMessage
}) => {

    const dispatch = useDispatch();
    const appendGroups = useSelector(selectAppendGroups);


    const handleDownloadCSV = () => {
        const notSkipTraced = preflightResponse?.contactsMissingPhoneNumberNotSkipTraced || [];

        const payload = {
            fileNamePrefix: 'MissingPhoneNumbers',
            contactIds: notSkipTraced
        }

        dispatch(downloadContactsWithNoNumber(
            payload,
            () => {
                // close modal after download completes
                onClose();
            },
            () => {
                showToastMessage("error", "Something went wrong. Please try again.");
            }
        ));
    };

    const handleSkipTraceNow = () => {
        const contactIds = preflightResponse?.contactsMissingPhoneNumberNotSkipTraced || [];

        // Close both this modal and PushtoBatchDialer before opening SkipTraceModal
        onClose();

        dispatch(getAppendJobEstimate(
            { contactIds, appendMode: "BOTH", reprocessEnabled: false },
            ({ response, error }) => {
                if (error) {
                    console.error("Error fetching estimate:", error);
                    showToastMessage("error", "Something went wrong. Please try again.");
                    return;
                }
                const { message } = response || {};
                if (message?.includes("There is an existing append job")) {
                    dispatch(InfoAlert.open({
                        title: "Skip Trace in Progress",
                        infoText: "There is a Skip Trace currently in progress. Please try again once it is complete.",
                    }));
                } else {
                    dispatch(SkipTraceModal.open({
                        groups: appendGroups,
                        reprocessEnabled: false,
                        contactIds,
                    }));
                }
            }
        ));
    };

    return (
        <>
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                isCloseButton={false}
                uniqId="push-to-BatchDialer"
                borderRadius="12px"
                modalClassName={css.missingphoneModal}
                className={classNames(css.clsAccPageModals, css.clsBillingModal)}
            >
                <div className={css.modalContainer}>
                    <div className={css.headertxt}>
                        <span>Missing Phone Numbers</span>
                    </div>
                    <div className={css.content}>
                        <span className={css.contenttxt}>
                            {missingCount} {missingCount === 1 ? "Property" : "Properties"} in "{campaignName}" don't have phone numbers yet.
                            You can download a CSV to review them, skip trace now to find contact details,
                            or continue pushing them to BatchDialer without skip tracing.
                        </span>
                    </div>
                    <div className={css.buttonWrapper}>
                        <button className={css.downloadBtn} onClick={handleDownloadCSV}>
                            <span className={css.downloadBtnLabel}>Download CSV</span>
                        </button>
                        <button className={css.skipTraceBtn} onClick={handleSkipTraceNow}>
                            <span className={css.skipTraceBtnLabel}>Skip Trace Now</span>
                        </button>
                        <button className={css.cwstBtn} onClick={onContinueWithoutSkipTrace}>
                            <span className={css.cwstBtnLabel}>Continue without Skip Tracing</span>
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default MissingPhoneNumbers;